import React, {Fragment, useCallback, useEffect} from 'react';
import Checkbox from '../../Forms/Checkbox';
import DropDownInput from '../../Forms/Dropdown';
import Input from '../../Forms/Input';
import InputDatePicker from '../../Forms/InputDatePicker';
import $ from 'jquery';
import { ValidateData } from '../../../inc/Validation';
import NewInputDatePicker from '../../Forms/NewInputDatePicker';
import PaginatedDropdown from '../../Forms/PaginatedDropdown';

    //Component For Mapping Field Input Boxes.

    // ** Props 
        {/* 
            mainClassName,
            className, 
            mainTitle,
            required,
            inputClassName,
            disable,
            type,
            inputType,
            label,
            isChecked,
            value,
            gridObjectFunction,
            id,
            forRendererFields -> function for grid
        */}
    // ----

    // let textBoxInputSettings = [ 
    //     {label:Helper.getLabel(props.language,'',""), className: '', inputType: "text/number/checkbox/datepicker/dropdown", name:'', id:'', }
    // ]

const FieldsRenderer = ({ fieldsArray, updateState, currentState, forRendererFields}) => {
    const onInputCheckboxChangeHandler = (name, value) => {  
        updateState((prevState) => {
            return {
                ...prevState,
                [name]:value
            }
        })
    }

    const onInputDatePickerChangeHandler = (name, input) => {
        updateState((prevState) => {
            return {
                ...prevState,
                [name]:input
            }
        })
    } 
    const onInputDatePickerChangeHandlerNew = ( value,name) => {
        updateState((prevState) => {
            return {
                ...prevState,
                [name]:value
            }
        })
    } 
      
    const onInputChangeHandler = useCallback((e) => {
        if (e.target.value !== currentState[e.target.name]) {
            updateState((prevState) => {
                return {
                    ...prevState,
                    [e.target.name]: e.target.value
                }
            })
        }
    }, [currentState])

    
  return (
    <div className='row'>
        {fieldsArray.map((item,key) => { 
            return (
            <>
                    <div className={`mt-2 col-12 ${item.mainClassName ? item.mainClassName : 'd-none'}`}>
                        <h3 className='mb-3'>{item.mainTitle ? item.mainTitle : null}</h3>
                    </div>
                    {item.inputBoxData ? item.inputBoxData.map((element, key) => {
                        return (
                            <div className={item.className ? item.className : 'col-lg-6'} key={key}>
                                {element.inputType == "text" && 
                                    <Input type='text' id={element.id ? element.id : null} required={element.required ? element.required : false} disable={element.disable ? element.disable : false} name={element.name} label={element.label} onChange={onInputChangeHandler} value={currentState[element.name]} />
                                }
                                {element.inputType == "password_eye" && 
                                    <Input inputType='password_eye' id={element.id ? element.id : null} required={element.required ? element.required : false} disable={element.disable ? element.disable : false} name={element.name} label={element.label} onChange={onInputChangeHandler} value={currentState[element.name]} />
                                }
                                {element.inputType == "number" && 
                                    <Input inputType='number' id={element.id ? element.id : null} required={element.required ? element.required : false} disable={element.disable ? element.disable : false} name={element.name} label={element.label} onChange={onInputChangeHandler} value={currentState[element.name]} />
                                }
                                {element.inputType == "dropdown" && 
                                    <DropDownInput placeHolder={element.placeHolder ? element.placeHolder : null} ajax={element.ajax ? element.ajax : null} id={element.id ? element.id : null} required={element.required ? element.required : false} isDisable={element.disable ? element.disable : false} label={element.label} options={element.options ? element.options : []} value={currentState[element.name]} name={element.name} onChange={onInputChangeHandler} reRenderRequired={element.reRenderRequired}  />
                                }
                                {element.inputType == "paginated_dropdown" && 
                                    <PaginatedDropdown options={element.options ? element.options : []} pagination={true} apiUrl={element.apiUrl ? element.apiUrl : null} currentSearchTerm={element.currentSearchTerm ? element.currentSearchTerm : null} allDataRef={element.allDataRef ? element.allDataRef : null} mapFunction={element.mapFunction ? element.mapFunction : null} reRenderRequired={true} placeHolder={element.placeHolder ? element.placeHolder : null} label={element.label ? element.label : null} required={element.required ? element.required : false} id={element.id ? element.id : null} name={element.name ? element.name : null} onChange={onInputChangeHandler} value={currentState[element.name]} />
                                }
                                {element.inputType == "checkbox" &&
                                    <Checkbox required={element.required ? element.required : false} id={element.id ? element.id : null} type={element.inputType} name={element.name} onChange={onInputCheckboxChangeHandler} disableWithoutIcon={element.disable ? element.disable : false} label={element.label} isChecked={currentState && (currentState[element.name] == 'on' || currentState[element.name])} /> 
                                }
                                {element.inputType == "datepicker" &&
                                    <InputDatePicker id={element.id ? element.id : null} disable={element.disable ? element.disable : false} value={currentState[element.name]} label={element.label} name={element.name} inputClassName={element.inputClassName} required={element.required ? element.required : false} onChange={onInputDatePickerChangeHandler}  /> 
                                }
                                {element.inputType == "datepicker_new" &&
                                    <NewInputDatePicker empty={element.emptyDate} timePicker={element.timePicker ? element.timePicker : false} id={element.id ? element.id : null} disable={element.disable ? element.disable : false} value={currentState[element.name]} label={element.label} name={element.name}  required={element.required ? element.required : false} onChange={onInputDatePickerChangeHandlerNew}  /> 
                                }
                                {element.inputType == "textarea" && 
                                    <div className='textarea_default'> 
                                        <label className='mb-2'>{element.label ? element.label : null}{element.required && <span style={{ color: 'red' }}>*</span>}</label>
                                        <textarea id={element.id ? element.id : null} disable={element.disable ? element.disable : false} value={currentState[element.name]} name={element.name} inputClassName={element.inputClassName} onChange={onInputChangeHandler}  /> 
                                    </div>
                                }
                            </div>
                        )
                    }): null}
                    {!item.inputBoxData && 
                    <div className={item.className ? item.className : 'col-lg-6'} key={key}>
                        {item.inputType == "text" && 
                            <Input type='text' id={item.id ? item.id : null} required={item.required ? item.required : false} disable={item.disable ? item.disable : false} name={item.name} label={item.label} onChange={onInputChangeHandler} value={currentState && currentState[item.name]} /> 
                        }
                        {item.inputType == "password_eye" && 
                            <Input inputType='password_eye' id={item.id ? item.id : null} required={item.required ? item.required : false} disable={item.disable ? item.disable : false} name={item.name} label={item.label} onChange={onInputChangeHandler} value={currentState && currentState[item.name]} /> 
                        }
                        {item.inputType == "number" && 
                            <Input inputType='number' id={item.id ? item.id : null} required={item.required ? item.required : false} disable={item.disable ? item.disable : false} name={item.name} label={item.label} onChange={onInputChangeHandler} value={currentState && currentState[item.name]} /> 
                        }
                        {item.inputType == "dropdown" && 
                            <DropDownInput placeHolder={item.placeHolder ? item.placeHolder : null} ajax={item.ajax ? item.ajax : null} id={item.id ? item.id : null} required={item.required ? item.required : false} isDisable={item.disable ? item.disable : false} label={item.label} options={item.options ? item.options : []} value={currentState && currentState[item.name]} name={item.name} onChange={onInputChangeHandler} reRenderRequired={item.reRenderRequired} /> 
                        }
                        {item.inputType == "paginated_dropdown" && 
                            <PaginatedDropdown required={item.required ? item.required : false} options={item.options ? item.options : []} pagination={true} apiUrl={item.apiUrl ? item.apiUrl : null} currentSearchTerm={item.currentSearchTerm ? item.currentSearchTerm : null} allDataRef={item.allDataRef ? item.allDataRef : null} mapFunction={item.mapFunction ? item.mapFunction : null} reRenderRequired={true} placeHolder={item.placeHolder ? item.placeHolder : null} label={item.label ? item.label : null} id={item.id ? item.id : null} name={item.name ? item.name : null} onChange={onInputChangeHandler} value={currentState[item.name]} />
                        }
                        {item.inputType == "checkbox" &&
                            <Checkbox required={item.required ? item.required : false} id={item.id ? item.id : null} type={item.inputType} name={item.name} onChange={onInputCheckboxChangeHandler} disableWithoutIcon={item.disable ? item.disable : false} label={item.label} isChecked={currentState && (currentState[item.name] == 'on' || currentState[item.name])} />
                        }
                        {item.inputType == "datepicker" &&
                            <InputDatePicker id={item.id ? item.id : null} disable={item.disable ? item.disable : false} value={currentState[item.name]} label={item.label} name={item.name} inputClassName={item.inputClassName} required={item.required ? item.required : false} onChange={onInputDatePickerChangeHandler}  /> 
                        }
                        {item.inputType == "datepicker_new" &&
                            <NewInputDatePicker timePicker={item.timePicker ? item.timePicker : false} empty={item.emptyDate} id={item.id ? item.id : null} disable={item.disable ? item.disable : false} value={currentState && currentState[item.name]} label={item.label} name={item.name} inputClassName={item.inputClassName} required={item.required ? item.required : false} onChange={onInputDatePickerChangeHandlerNew}  /> 
                        }
                        {item.inputType == "textarea" && 
                            <div className='textarea_default'> 
                                <label className='mb-2'>{item.label}{item.required && <span style={{ color: 'red' }}>*</span>}</label>
                                <textarea className='descriptionTextarea' id={item.id ? item.id : null} disable={item.disable ? item.disable : false} value={currentState[item.name]} name={item.name} onChange={onInputChangeHandler}  /> 
                            </div>
                        }
                    </div>
                    }
            </>
            )
        })}
    </div>
  )
}

export default FieldsRenderer;